const user = JSON.parse(localStorage.getItem("auth"));
let arra=[]
export default arra
